import { setConfiguration } from '@configuratorware/configurator-frontendgui/App/configuration';
import Api from '@configuratorware/configurator-frontendgui/Framework/Api';
import VisualizationService from '../Services/Visualization';
import CustomConfiguratorScreen from './App/Screens/ConfiguratorScreen';
import CustomItemOverviewScreen from './App/Screens/ItemOverviewScreen';
import ConfiguratorService from './App/Services/ConfiguratorService';
import configuratorReducer from './App/Reducers/Configurator/Reducer';

const prod = process.env.NODE_ENV === 'production';

const envDomains = {
  test: '',
  int: '',
  local: 'http://int.3dlogo.local',
  prod: '',
};

const domain = envDomains[prod ? 'prod' : 'local'];

const query = new URLSearchParams(location.search);

const adminMode = query.get('_adminmode');

const customApplicationConfiguration = {
  network: {
    host: domain,
    baseURL: `${domain}/frontendapi/`,
    adminBaseURL: `${domain}/api/`,
    imageURL: `${domain}`,
    resourcesURL: `${domain}`,
  },
  designer: {
    enabled: true,
    allowedImageUploadFormats: ['svg', 'pdf', 'eps', 'ai'],
  },
  screens: {
    Configurator: CustomConfiguratorScreen,
    ItemOverview: CustomItemOverviewScreen,
  },
  services: {
    visualization: VisualizationService,
    ConfiguratorService,
  },
  reducers: {
    configurator: configuratorReducer,
  },
};

setConfiguration(customApplicationConfiguration);

if (adminMode) {
  Api.setCacheControlHeader('no-cache');
}

export default customApplicationConfiguration;
